module.exports = __webpack_public_path__ + "static/media/Footballwatchparty.dda8c5b4.png";